import { forwardRef } from "react";
import { Text as NativeText, type TextStyle } from "react-native";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../../useAppTheme";

type Props = {
	content: string;
	contextId?: string;
	onPress?: (contextId?: string) => void;
	inheritedStyle?: TextStyle;
};

export const HighlightedText = forwardRef<NativeText, Props>(
	({ content, contextId, onPress, inheritedStyle }, ref) => {
		const theme = useAppTheme();
		return (
			<NativeText ref={ref}>
				<Text
					style={{
						color: theme.colors.shadow,
						padding: 2,
						borderRadius: 4,
						backgroundColor: theme.palette.highlight.main,
						fontFamily: inheritedStyle?.fontFamily,
						fontWeight: inheritedStyle?.fontWeight,
						fontStyle: inheritedStyle?.fontStyle,
						textDecorationLine: inheritedStyle?.textDecorationLine,
					}}
					onPress={onPress ? () => onPress(contextId) : undefined}
				>
					{content}
				</Text>
			</NativeText>
		);
	},
);
